export type signInProvider = "google";

export const REDIRECT_AFTER_LOGIN_HREF_LS_KEY = "redirectAfterLogin";
